"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortTableRows = void 0;
const typings_1 = require("Views/Partials/Components/TableCore/typings");
const sortTableRows = (rows, sortOrder, sortColumn) => {
    const sortStrings = (rowOne, rowTwo) => {
        return sortOrder === typings_1.OrderTypeEnum.Ascending
            ? rowOne[sortColumn].localeCompare(rowTwo[sortColumn])
            : rowTwo[sortColumn].localeCompare(rowOne[sortColumn]);
    };
    return [...rows].sort(sortStrings);
};
exports.sortTableRows = sortTableRows;
